import { 
  addDoc, 
  collection, 
  deleteDoc, 
  doc, 
  getDocs, 
  updateDoc, 
  query, 
  where 
} from "firebase/firestore";

import { 
  getStorage, 
  ref, 
  uploadBytes, 
  getDownloadURL 
} from "firebase/storage";

import { getAuth } from "firebase/auth";

import { 
  SERVICE_DELETE, 
  SERVICE_ERROR, 
  SERVICE_LOADING, 
  SERVICE_SUCCESS 
} from "./type";

import { db } from "../../db/firebase";


export const loadServices = async (dispatch: any) => {
  dispatch({ type: SERVICE_LOADING });

  try {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) throw new Error("Usuário não autenticado");

    const q = query(
      collection(db, "services"),
      where("userId", "==", user.uid)
    );

    const querySnapshot = await getDocs(q);

    const list: any[] = [];

    querySnapshot.forEach((doc) => {
      list.push({ id: doc.id, ...doc.data() });
    });

    dispatch({
      type: SERVICE_SUCCESS,
      payload: list
    });

  } catch (err: any) {
    dispatch({
      type: SERVICE_ERROR,
      payload: err.message
    });
  }
};


export const createServices = async (dispatch: any, data: any) => {
  try {

    dispatch({ type: SERVICE_LOADING });

    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) throw new Error("Usuário não autenticado");

    const storage = getStorage();
    let fotoURL = null;

    if (data.foto) {
      const file = data.foto;

      const storageRef = ref(
        storage,
        `services/${user.uid}_${Date.now()}_${file.name}`
      );

      await uploadBytes(storageRef, file);
      fotoURL = await getDownloadURL(storageRef);
    }

    const cleanData = {
      ...data,
      foto: fotoURL,
      userId: user.uid,
      createdAt: new Date()
    };

    const docRef = await addDoc(collection(db, "services"), cleanData);

    dispatch({
      type: SERVICE_SUCCESS,
      payload: { id: docRef.id, ...cleanData }
    });

  } catch (error: any) {

    dispatch({
      type: SERVICE_ERROR,
      payload: error.message
    });

  }
};


export const updateServices = async (dispatch: any, data: any) => {
  try {

    dispatch({ type: SERVICE_LOADING });

    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) throw new Error("Usuário não autenticado");

    if (!data.id) {
      throw new Error("ID não informado");
    }

    const storage = getStorage();
    let fotoURL = data.foto;

    if (data.foto instanceof File) {

      const storageRef = ref(
        storage,
        `services/${user.uid}_${Date.now()}_${data.foto.name}`
      );

      await uploadBytes(storageRef, data.foto);
      fotoURL = await getDownloadURL(storageRef);
    }

    const docRef = doc(db, "services", data.id);

    const updatedData = {
      ...data,
      foto: fotoURL,
      userId: user.uid
    };

    delete updatedData.id;

    await updateDoc(docRef, updatedData);

    dispatch({
      type: SERVICE_SUCCESS,
      payload: { id: data.id, ...updatedData }
    });

  } catch (error: any) {

    dispatch({
      type: SERVICE_ERROR,
      payload: error.message
    });

  }
};


export const deleteServices = async (dispatch: any, id: string) => {
  try {

    dispatch({ type: SERVICE_LOADING });

    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) throw new Error("Usuário não autenticado");

    await deleteDoc(doc(db, "services", id));

    dispatch({
      type: SERVICE_DELETE,
      payload: id
    });

  } catch (error: any) {

    dispatch({
      type: SERVICE_ERROR,
      payload: error.message
    });

  }
};